import { GraphSchema } from '@ta/server';

export interface IdentityVerificationPayload {
  redirectUrl: string;
  verificationId: string;
}

export const identityVerificationPayloadProps = new GraphSchema<IdentityVerificationPayload>([
  'redirectUrl',
  'verificationId',
]);
